import { createSelector } from 'reselect';

// Config
import {
  getSessionExpiringAnnouncedSelector,
  getSessionExpiredAnnouncedSelector,
} from '@redux/reducers/app/appSelector';
import {
  getSessionExpiryData,
} from '@redux/reducers/bff/bffSelector';
import {
  getSessionWarningAfterTimeSelector,
} from '@redux/reducers/config/configSelector';

const sessionExpiryCounterState = createSelector([
  getSessionExpiringAnnouncedSelector,
  getSessionExpiredAnnouncedSelector,
  getSessionExpiryData,
  getSessionWarningAfterTimeSelector,
], (
  sessionExpiringAnnounced,
  sessionExpiredAnnounced,
  sessionExpiryData,
  sessionWarningAfterTime,
) => ({
  sessionExpiringAnnounced,
  sessionExpiredAnnounced,
  sessionExpiryData,
  sessionWarningAfterTime,
}));

export default sessionExpiryCounterState;
